/**
 * Gen Tabs - Tab System for Split Product Sections
 *
 * Structure:
 * 1. product-content-tabs: Tab navigation (desktop) + mobile Description toggle
 * 2. gen_* section: PDP content with .ap-pdp
 * 3. product-content-after-gen: Other tab panels
 *
 * Desktop: Tab navigation shows/hides content
 * Mobile: All content visible, collapsible accordion behavior
 */

(function () {
    "use strict";
  
    var MOBILE_BREAKPOINT = 1000;
  
    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }
  
    function initGenTabs() {
      // Find .ap-pdp element
      var apPdpElement = document.querySelector(".ap-pdp");
      if (!apPdpElement) {
        return;
      }
  
      // Find the gen section (parent shopify-section of .ap-pdp)
      var genSection = apPdpElement.closest(".shopify-section");
      
      // Find after-gen section
      var afterGenSection = document.querySelector(".shopify-section--product-content-after-gen");
      
      // Find all after-gen content panels
      var afterGenPanels = afterGenSection 
        ? afterGenSection.querySelectorAll("[data-tab-content]") 
        : [];
  
      // Find tab buttons (desktop)
      var tabButtons = document.querySelectorAll(".gen-tab-btn");
  
      // Find mobile description toggle button
      var mobileDescButton = document.querySelector(".gen-mobile-desc-toggle");
  
      /**
       * Desktop: Show content for target, hide others
       */
      function showDesktop(target) {
        // Handle gen section (PDP)
        if (genSection) {
          if (target === "gen-base") {
            genSection.style.display = "";
          } else {
            genSection.style.display = "none";
          }
        }
  
        // Handle after-gen panels
        for (var i = 0; i < afterGenPanels.length; i++) {
          var panel = afterGenPanels[i];
          var panelTarget = panel.getAttribute("data-tab-content");
          
          if (panelTarget === target) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        }
      }
  
      /**
       * Mobile: Show all content
       */
      function showMobile() {
        // Show gen section
        if (genSection) {
          genSection.style.display = "";
          genSection.classList.remove("gen-mobile-collapsed");
        }
  
        // Show all after-gen panels
        for (var i = 0; i < afterGenPanels.length; i++) {
          afterGenPanels[i].removeAttribute("hidden");
        }
  
        // Reset mobile toggle state
        if (mobileDescButton) {
          mobileDescButton.setAttribute("aria-expanded", "true");
        }
      }
  
      /**
       * Update tab button active states
       */
      function updateActiveButton(activeButton) {
        for (var i = 0; i < tabButtons.length; i++) {
          tabButtons[i].setAttribute("aria-expanded", "false");
          tabButtons[i].classList.remove("is-active");
        }
        if (activeButton) {
          activeButton.setAttribute("aria-expanded", "true");
          activeButton.classList.add("is-active");
        }
      }
  
      /**
       * Handle tab button click (desktop)
       */
      function handleTabClick(e) {
        if (isMobile()) return;
  
        e.preventDefault();
        e.stopPropagation();
  
        var button = e.currentTarget;
        var target = button.getAttribute("data-tab-target");
        if (!target) return;
  
        showDesktop(target);
        updateActiveButton(button);
      }
  
      /**
       * Handle mobile description toggle click
       */
      function handleMobileDescToggle(e) {
        e.preventDefault();
        
        if (!genSection || !mobileDescButton) return;
  
        var isExpanded = mobileDescButton.getAttribute("aria-expanded") === "true";
  
        if (isExpanded) {
          // Collapse
          mobileDescButton.setAttribute("aria-expanded", "false");
          genSection.classList.add("gen-mobile-collapsed");
        } else {
          // Expand
          mobileDescButton.setAttribute("aria-expanded", "true");
          genSection.classList.remove("gen-mobile-collapsed");
        }
      }
  
      /**
       * Handle resize
       */
      function handleResize() {
        if (isMobile()) {
          showMobile();
        } else {
          // Desktop: apply current active tab state
          var activeButton = document.querySelector(".gen-tab-btn[aria-expanded='true']");
          if (activeButton) {
            var target = activeButton.getAttribute("data-tab-target");
            showDesktop(target);
          } else if (tabButtons.length > 0) {
            showDesktop("gen-base");
            updateActiveButton(tabButtons[0]);
          }
        }
      }
  
      // Attach click handlers to tab buttons
      for (var i = 0; i < tabButtons.length; i++) {
        tabButtons[i].addEventListener("click", handleTabClick);
      }
  
      // Attach handler to mobile description toggle
      if (mobileDescButton) {
        mobileDescButton.addEventListener("click", handleMobileDescToggle);
      }
  
      // Listen for resize
      var resizeTimeout;
      window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 100);
      });
  
      // Initial state
      if (isMobile()) {
        showMobile();
      } else {
        showDesktop("gen-base");
        if (tabButtons.length > 0) {
          updateActiveButton(tabButtons[0]);
        }
      }
    }
  
    // Initialize
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initGenTabs);
    } else {
      setTimeout(initGenTabs, 100);
    }
  })();
  